export enum FontWeightToken {
  regular = '400',
  medium = '500',
  semiBold = '600',
  bold = '700',
}

export default FontWeightToken

export type TFontWeight = 'regular' | 'medium' | 'semiBold' | 'bold'
